<template>
  <div class="panel p-1">
    <div v-if="title || $slots.toolbar" class="panel-hdr">
      <h2>
        {{ title }}

        <w-tooltip v-if="tooltip">
          {{ tooltip }}
        </w-tooltip>
      </h2>

      <div class="panel-toolbar">
        <slot name="toolbar" />
      </div>
    </div>

    <div class="panel-container p-3">
      <slot />
    </div>

    <div v-if="$slots.footer" class="card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Panel
// @group panel
export default {
  components,
  props: {
    // Tytuł panelu
    title: {
      type: String,
      required: false,
      default: undefined
    },
    // Tooltip w tytule
    tooltip: {
      type: String,
      required: false,
      default: undefined
    }
  }
};
</script>
